import React from "react";

import { Box } from "@chakra-ui/react";
import { ReactComponent as CloseIcon } from "assets/icons/close-icon-in-grey-bg.svg";

import { Paragraph2 } from "ui/typography";

import { filterHeaderWrapperCss } from "./styles";
import { IFilterHeaderProps } from "./types";

export const FilterHeader = (props: IFilterHeaderProps) => {
  const { handleToggleFilter, isLoading, title } = props;

  return (
    <Box css={filterHeaderWrapperCss}>
      <div className="flex justify-between h-[22px] w-full">
        <Paragraph2
          fontWeight="600"
          lineHeight="22px"
        >
          {title ?? "Filter By"}
        </Paragraph2>
        <div
          className={`${isLoading ? "cursor-not-allowed" : "cursor-pointer"}`}
          onClick={!isLoading ? handleToggleFilter : undefined}
        >
          <CloseIcon />
        </div>
      </div>
    </Box>
  );
};
